/* eslint-disable max-len */

export const ANYWHERE_LOCATION_JSON = {
  city: 'Qualquer lugar',
  coordinates: { lat: '', lon: '' },
  slug: ''
};

export const ANYWHERE_LOCATION = 'Qualquer lugar';

export const NEAR_TO_YOU_LABEL = 'Perto de você';

export const DEFAULT_IMAGE =
  'https://d1gkntzr8mxq7s.cloudfront.net/65df83b3c4d68.svg';

export const DEFAULT_IMAGE_BASE64 =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAQAAAD8IX00AAAAEElEQVR42mP8ZswABIwoFAAs5QN/jiaZIgAAAABJRU5ErkJggg==';

export const PAGES_URL = {
  events: '/eventos',
  favorite: '/favoritos',
  helpCenter: 'https://ajuda.sympla.com.br/hc/pt-br/',
  home: '/',
  login: '/login',
  myAccount: '/minha-conta',
  myTickets: '/meus-pedidos',
  organizer: 'https://organizador.sympla.com.br/',
  organizerArea: '/meus-eventos',
  organizerCreateEvent: '/criar-evento?presencial=1',
  forgotPsw: '/esqueceu-a-senha',
  createAccount: '/criar-conta',
  categories: '/categorias',
  productor: '/produtor',
  helpCenterBileto: 'https://ajuda-bileto-sympla.zendesk.com/hc/pt-br',
  talkWithUs: 'https://ajuda.sympla.com.br/hc/pt-br/requests/new',
  talkWithUsBileto:
    'https://ajuda-bileto-sympla.zendesk.com/hc/pt-br/requests/new',
  sports: '/sports',
  sporty: '/esportivo'
};

export const FAQS_URL = {
  ticketCancellationRefund:
    'https://ajuda.sympla.com.br/hc/pt-br/search?utf8=%E2%9C%93&query=Cancelamento+ou+reembolso+de+ingressos',
  pendingPurchase:
    'https://ajuda.sympla.com.br/hc/pt-br/search?utf8=%E2%9C%93&query=Compra+pendente',
  ticketTransfer:
    'https://ajuda.sympla.com.br/hc/pt-br/search?utf8=%E2%9C%93&query=Troca+de+titularidade',
  howToAccessCertificate:
    'https://ajuda.sympla.com.br/hc/pt-br/search?utf8=%E2%9C%93&query=Como+acesso+meu+certificado',
  howToAccessMyAccount:
    'https://ajuda.sympla.com.br/hc/pt-br/search?utf8=%E2%9C%93&query=N%C3%A3o+consigo+acessar+minha+conta',
  invoiceIssuance:
    'https://ajuda.sympla.com.br/hc/pt-br/articles/38604842090004-Como-receber-a-nota-fiscal-da-minha-compra'
};

export const HASH_URL = {
  login: '#login',
  createAccount: '#criar-conta',
  forgotPsw: '#esqueceu-a-senha'
};

export const MATRIX_TYPE = {
  TOPIC: 'topic',
  HOME_MATRIX: 'home-matrix',
  MATRIX: 'matriz',
  HOME: 'home',
  SEARCH: 'search'
};

export const CLASS_TRACKING_GTM = {
  COLLECTION_CARD: 'sympla-category-card',
  EVENT_CARD: 'sympla-card'
};

export const ROUTE_TYPE = {
  SEARCH_BAR_DEFAULT_FILTER: 'search-bar-default-filter',
  COLLECTION: 'collection'
};

export const LIMITS = {
  EVENTS: 24,
  RESULT_EVENT: 12,
  EVENTS_OTHER_CITIES: 8,
  TRACK_MORE_EVENTS: 16,
  COLLECTION_EVENTS: 4,
  MOBILE: 16
};

export const ROUTE_SUFFIXES = {
  ALL_EVENTS: 'todos-eventos'
};

export const DEFAULT_LOCATION_RADIUS = 150;
